"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _find = _interopRequireDefault(require("lodash/find"));
var _map = require("../map");
var _Vector = _interopRequireDefault(require("ol/layer/Vector.js"));
var _Feature = _interopRequireDefault(require("ol/Feature.js"));
var _Point = _interopRequireDefault(require("ol/geom/Point.js"));
var _Projection = _interopRequireDefault(require("ol/proj/Projection.js"));
var _proj = require("ol/proj");
var _Vector2 = _interopRequireDefault(require("ol/source/Vector.js"));
var _Style = _interopRequireDefault(require("ol/style/Style.js"));
var _Icon = _interopRequireDefault(require("ol/style/Icon.js"));
var _Text = _interopRequireDefault(require("ol/style/Text.js"));
var _Fill = _interopRequireDefault(require("ol/style/Fill.js"));
var _Stroke = _interopRequireDefault(require("ol/style/Stroke.js"));
var _GeoJSON = _interopRequireDefault(require("ol/format/GeoJSON.js"));
var _MBTAT = _interopRequireDefault(require("../../../../assets/icons/MBTA-T.png"));
var _bus = _interopRequireDefault(require("../../../../assets/icons/bus.png"));
var _constants = require("../../../lib/constants");
var _rcTooltip = _interopRequireDefault(require("rc-tooltip"));
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// import ol from "openlayers";

// STYLES
var stationIconStyle = new _Style["default"]({
  /* image: image */
  image: new _Icon["default"]({
    anchor: [0.5, 0.5],
    anchorXUnits: 'fraction',
    anchorYUnits: 'fraction',
    opacity: 1,
    src: _MBTAT["default"]
  }),
  zIndex: _constants.TRAIN_STOP_Z_LEVEL,
  text: new _Text["default"]({
    font: 'bold 11px "Open Sans", "Arial Unicode MS", "sans-serif"',
    placement: 'point',
    offsetY: 20,
    fill: new _Fill["default"]({
      color: '#000'
    }),
    stroke: new _Stroke["default"]({
      color: '#fff',
      width: 3
    })
  })
});
var busStationIconStyle = new _Style["default"]({
  /* image: image */
  image: new _Icon["default"]({
    anchor: [0.5, 0.5],
    anchorXUnits: 'fraction',
    anchorYUnits: 'fraction',
    opacity: 1,
    src: _bus["default"]
  }),
  zIndex: _constants.BUS_STOP_Z_LEVEL,
  text: new _Text["default"]({
    font: 'bold 11px "Open Sans", "Arial Unicode MS", "sans-serif"',
    placement: 'point',
    offsetY: 20,
    fill: new _Fill["default"]({
      color: '#000'
    }),
    stroke: new _Stroke["default"]({
      color: '#fff',
      width: 3
    })
  })
});
var layer = new _Vector["default"]({
  visible: true,
  zIndex: _constants.STATION_LAYER_Z_LEVEL,
  minZoom: _constants.TRAIN_STOP_Z_LEVEL,
  updateWhileAnimating: true,
  updateWhileInteracting: true,
  declutter: false,
  name: "stations",
  style: function style(feature) {
    var currentZoom = _map.map.getView().getZoom();
    var showLabel = currentZoom >= _constants.STATION_LABEL_ZOOM;
    var showBus = currentZoom >= _constants.BUS_STOP_ZOOM;
    // console.log('show label: ', showLabel)
    var _feature$getPropertie = feature.getProperties(),
      name = _feature$getPropertie.stop_name,
      vehicleType = _feature$getPropertie.vehicle_type;
    var style = vehicleType ? busStationIconStyle : stationIconStyle;
    if (showLabel && !vehicleType) {
      style.getText().setText(name);
    } else {
      style.getText().setText('');
    }
    if (vehicleType && !showBus) {
      style = null;
    }
    return style;
  }
});
_map.map.addLayer(layer);
var stations = {
  handleUpdate: function handleUpdate(_ref) {
    var stopsGeoJson = _ref.stations,
      hovered = _ref.hovered;
    // if (layers.stations) {
    //   layer.set('minZoom', 1)
    // } else {
    layer.set('minZoom', _constants.TRAIN_STOP_ZOOM);
    // }
    //early cutoff for when layer is not visible or unavailable
    if (!stopsGeoJson || !stopsGeoJson.type) return;
    var stationsToRender = stopsGeoJson.features.filter(function (oneStop) {
      if (oneStop && oneStop.properties) {
        return true;
      }
      return false;
    });

    // set the features to this layer
    var features = new _GeoJSON["default"]({
      featureProjection: 'EPSG:3857'
    }).readFeatures({
      type: 'FeatureCollection',
      features: stationsToRender
    });
    layer.setSource(new _Vector2["default"]({
      features: features
    }));
  },
  getOverlay: function getOverlay(stopId, stopsGeoJson) {
    var _stop$properties;
    var features = stopsGeoJson.features;
    var stop = (0, _find["default"])(features, function (feat) {
      return feat.id === stopId;
    });
    if (!stop) {
      return null;
    }

    // set position
    var coords = stop.geometry.coordinates;
    _map.overlay.setPosition((0, _proj.transform)([coords[0], coords[1]], "EPSG:4326", "EPSG:900913"));
    _map.overlay.setProperties({
      layer: "stations",
      stopId: stopId
    });
    // output rendered content
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "overlay-content basic p-0"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        backgroundColor: "".concat(stop.properties.vehicle_type === 3 ? '#ffc72c' : '#000'),
        color: '#fff',
        borderRadius: '4px 4px 0px 0px'
      },
      className: "text-center py-2"
    }, (stop === null || stop === void 0 ? void 0 : (_stop$properties = stop.properties) === null || _stop$properties === void 0 ? void 0 : _stop$properties.stop_name) && /*#__PURE__*/_react["default"].createElement("h4", {
      className: "m-0"
    }, stop.properties.stop_name)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "p-3"
    }, Object.keys(stop.properties).map(function (key) {
      return /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          fontSize: 11,
          display: 'block',
          fontWeight: 'normal'
        },
        key: key
      }, key, ": ", /*#__PURE__*/_react["default"].createElement("strong", null, stop.properties[key]));
    })));
  },
  getHoverOverlay: function getHoverOverlay(stopId, stopsGeoJson) {
    var fullStop = stopsGeoJson.features.find(function (oneStop) {
      return oneStop.id === stopId;
    });
    if (fullStop.properties.board_here_for) {
      var coords = fullStop.geometry.coordinates;
      _map.overlay.setPosition((0, _proj.transform)([coords[0], coords[1]], "EPSG:4326", "EPSG:900913"));
      _map.overlay.setProperties({
        layer: "stations",
        stopId: stopId
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "overlay-content basic",
        style: {
          opacity: 0
        }
      }, /*#__PURE__*/_react["default"].createElement(_rcTooltip["default"], {
        key: "bus-stop-".concat(stopId),
        placement: "top",
        visible: true,
        overlay: "Board here for: ".concat(fullStop.properties.board_here_for),
        arrowContent: /*#__PURE__*/_react["default"].createElement("div", {
          className: "re-tooltip-arrow-inner"
        })
      }, /*#__PURE__*/_react["default"].createElement("span", null)));
    } else {
      return null;
    }
  }
};
var _default = stations;
exports["default"] = _default;